export function getCompMix(isArray = false) {
  let valueConfig = {
    type: [String, Number],
    required: true,
    default: "",
  };
  if (isArray) {
    valueConfig = {
      type: Array,
      required: true,
      default: () => [],
    };
  }

  return {
    props: {
      // 组件配置
      config: {
        type: Object,
        default() {
          return {};
        },
        required: true,
      },
      // v-model传入的值
      value: valueConfig,
      // 是否可编辑
      editable: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      computedValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
  };
}

/**
 * 组件公共mixins
 */
export default getCompMix(false);
